<template>
  <v-card outlined class="plan-card">
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title class="plan-title">{{
          plan.name
        }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title class="plan-subtitle">Serviços:</v-list-item-title>
        <v-list-item-title class="plan-item"
          >Até
          <strong>{{ plan.perks.phones }}</strong>
          números de WhatsApp</v-list-item-title
        >
        <v-list-item-title class="plan-item" style="padding-bottom: 0px;"
          >Até <strong>{{ plan.perks.links }}</strong> links
        </v-list-item-title>
        <v-list-item-subtitle class="plan-item"
          >(Canal de comunicação/Campanha)</v-list-item-subtitle
        >
        <v-list-item-title class="plan-item">
          <span v-if="plan.perks.redirections < 1000000"
            >Limite de
            <strong>{{ plan.perks.redirections }}</strong>
            Redirecionamentos</span
          >
          <span v-else>Redirecionamentos <strong>Ilimitados</strong></span>
        </v-list-item-title>
        <v-list-item-title class="plan-item">Mensagem Padrão</v-list-item-title>
        <v-list-item-title class="plan-item"
          >Frequência de <br />redirecionamento por número</v-list-item-title
        >
      </v-list-item-content>
    </v-list-item>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title class="plan-subtitle">Relatórios:</v-list-item-title>
        <v-list-item-title class="plan-reports">
          <span v-if="plan.reports.includes('report_redirect_phone')"
            >Redirecionamentos por Link</span
          >
          <span v-else><br /></span>
        </v-list-item-title>
        <v-list-item-title class="plan-reports">
          <span v-if="plan.reports.includes('report_redirect_phone')"
            >Redirecionamentos por Número</span
          >
          <span v-else><br /></span>
        </v-list-item-title>
        <v-list-item-title class="plan-reports">
          <span v-if="plan.reports.includes('report_redirect_day')"
            >Redirecionamentos por Dia</span
          >
          <span v-else><br /></span>
        </v-list-item-title>
        <v-list-item-title class="plan-reports" style="padding-bottom: 0px;">
          <span v-if="plan.reports.includes('report_redirect_hour')"
            >Redirecionamentos por Hora</span
          >
          <span v-else><br /></span>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item>
      <v-list-item-content class="pb-0 mb-0 pt-2 mt-2">
        <v-list-item-title>
          <div v-if="plan.free" style="width: 100%; height: 40px;"></div>
          <v-select
            :items="plan.prices"
            :value="value"
            v-on:input="$emit('input', $event)"
            v-else
            item-value="days"
            dense
            hide-details
            outlined
          >
            <template v-slot:selection="{ item }">
              <span style="text-align:center; width:100%">
                {{ formatPeriodPlan(item) }}&nbsp;<v-chip
                  color="#fbce3b"
                  x-small
                  >{{ formatDiscountPlan(item) }}</v-chip
                >
              </span>
            </template>
            <template v-slot:item="{ item }">
              <span style="text-align:center; width:100%">
                {{ formatPeriodPlan(item) }}&nbsp;<v-chip
                  color="#fbce3b"
                  x-small
                  >{{ formatDiscountPlan(item) }}</v-chip
                >
              </span>
            </template>
          </v-select>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item>
      <v-list-item-content class="pb-0 mb-0">
        <v-list-item-title style="text-align:center">
          <div
            style="width: 100%; height: 42px;"
            v-if="
              formatFinalValue(plan.prices).old ==
                formatFinalValue(plan.prices).new
            "
          ></div>
          <span class="plan-value-total" v-else>
            <strike>R$ {{ formatFinalValue(plan.prices).old }}</strike
            >&nbsp; <strong>R$ {{ formatFinalValue(plan.prices).new }}</strong
            ><br />
            <span class="plan-value-sub">equivalente a</span><br />
          </span>

          <span>
            <span class="plan-value-min">R$&nbsp;</span>
            <span class="plan-value">{{
              formatFinalValue(plan.prices).month
            }}</span>
            <span
              class="plan-value-min"
              v-if="formatFinalValue(plan.prices).month != '0,00'"
              >/mês</span
            >
          </span>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-card-actions>
      <v-btn
        block
        color="secondary"
        v-on:click="selectPlan(plan.id)"
        :disabled="plan.isCurrent"
      >
        <span v-if="plan.isCurrent">Plano Atual</span>
        <span v-else>Selecionar</span>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  props: ["plan", "value"],
  data: () => ({}),
  computed: {},
  methods: {
    formatAsPrice: function(price) {
      return price
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
        .replace(/(.*)(\.)(\d{2})/g, "$1,$3");
    },
    formatFinalValue: function(prices) {
      let item = [];

      prices.forEach((element) => {
        if (element.days == this.value) {
          item = element;
        }
      });
      if (item.length == 0) {
        return {
          old: this.formatAsPrice(0),
          new: this.formatAsPrice(0),
          month: this.formatAsPrice(0)
        };
      }
      return {
        old: this.formatAsPrice(item.original),
        new: this.formatAsPrice(item.new_price),
        month: this.formatAsPrice(item.new_price / item.months)
      };
    },
    formatPeriodPlan: function(item) {
      if (item.original == 0) return "Gratuito";

      let periodText = "";
      if (item.days == 30) periodText = "Mensal";
      if (item.days == 90) periodText = "Trimestral";
      if (item.days == 365) periodText = "Anual";
      return periodText;
    },
    formatDiscountPlan: function(item) {
      let discount = "";
      if (item.discount == 0) discount = "Sem desconto";
      else discount = item.discount + "% OFF";
      return discount;
    },
    selectPlan: function(PlanId) {
      this.$emit("select-plan", PlanId);
    }
  },
  mounted() {
    //
  }
});
</script>
<style>
.plan-card {
  user-select: none;
}
.plan-title {
  text-align: center;
  color: #60ba8e;
  text-transform: uppercase;
  font-size: 20px;
}
.plan-subtitle {
  text-align: center;
  font-weight: 500;
  text-transform: uppercase;
  padding-bottom: 15px;
  font-size: 14px;
}
.plan-item {
  text-align: center;
  padding-bottom: 10px;
  font-size: 14px;
}
.plan-reports {
  text-align: center;
  padding-bottom: 10px;
  font-size: 14px;
}
.plan-value-total {
  font-size: 18px;
}
.plan-value-sub {
  font-size: 14px;
  color: #11111195;
}
.plan-value {
  font-size: 30px;
  color: #132237;
}
.plan-value-min {
  font-size: 14px;
  color: #132237;
}
</style>
